/* eslint-disable @typescript-eslint/no-var-requires */
/**
 * 配置信息
 */

// 企业信息
export const COMPANY_INFO = {
  PHONE: "400-6522-686",
  MAIL: "trth@163.com",
  ADDRESS: "深圳市南山区生态湾科技园11栋A座",
  COPY_RIGHT: "Copyright© 2018 - 2025 天润泰和（深圳）科技有限公司",
  ICP: "粤ICP备2022048153号-2",
  BEI_AN: "粤公网安备 440303022001184号",
};

// 优势列表
export const ADVANTAGE_LIST = [
  {
    icon: "icon-icon_shuiwuchouhua",
    title: "税务筹划",
    desc: "专业服务团队",
  },
  {
    icon: "icon-icon_guquanjiegou",
    title: "股权结构设计",
    desc: "专业服务团队",
  },
  {
    icon: "icon-icon_zhengqixietiao",
    title: "政企协调",
    desc: "专业服务团队",
  },
  {
    icon: "icon-icon_shuiwushenji",
    title: "税务审计",
    desc: "专业服务团队",
  },
  {
    icon: "icon-icon_renliwaibao",
    title: "人力外包",
    desc: "专业服务团队",
  },
];

// 外部链接
export const OTHER_LINKS_GROUP = [
  {
    groupName: "关于我们",
    links: [
      {
        name: "公司介绍",
        href: "https://www.bhlinggong.com/about.html#company-info",
      },
      {
        name: "合规资质",
        href: "https://www.bhlinggong.com/about.html#certification",
      },
      {
        name: "联系我们",
        href: "https://www.bhlinggong.com/about.html#contact-us",
      },
    ],
  },
  {
    groupName: "佰和资讯",
    links: [
      {
        name: "灵活用工",
        href: "https://portal.bhlinggong.com/consultation.html?type=3",
      },
      {
        name: "行业资讯",
        href: "https://portal.bhlinggong.com/consultation.html?type=2",
      },
      {
        name: "平台公告",
        href: "https://portal.bhlinggong.com/consultation.html?type=1",
      },
      // {
      //   name: "采访登记",
      //   href: "/",
      // },
    ],
  },
  // {
  //   groupName: "技术支持",
  //   links: [
  //     {
  //       name: "帮助中心",
  //       href: "/",
  //     },
  //     {
  //       name: "意见反馈",
  //       href: "/",
  //     },
  //     {
  //       name: "佰和论坛",
  //       href: "/",
  //     },
  //   ],
  // },
  {
    groupName: "佰和服务",
    links: [
      {
        name: "平台优势",
        href: "https://www.bhlinggong.com/service.html#platform-advantages",
      },
      {
        name: "风控管理",
        href: "https://www.bhlinggong.com/service.html#risk-management",
      },
      {
        name: "支撑保障",
        href: "https://www.bhlinggong.com/service.html#support-and-guarantee",
      },
    ],
  },
];

// 二维码
export const QR_CODES = [
  {
    codeHref: require("./assets/imgs/qrcode.jpg"),
    title: "微信小程序",
  },
];
